import { ZendeskService } from '@zendesk/services/zendesk.service';
import { ZENDESK_STORE } from '@zendesk/stores/zendesk.store';

export const ZENDESK_PROVIDERS = [ZendeskService, ZENDESK_STORE];
